var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.78 159.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d7006c;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke:#ba458c;stroke-miterlimit:10;}.cls-4{fill:#e13433;}.cls-5{fill:#ca247c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    className: "cls-1",
    d: "M44.51,157a45.74,45.74,0,0,1-7.77-3.21c-13.16-7-18.85-25.7-23.61-38.85C4.7,91.7-1.94,63.24.51,38.38,2.81,15,14.86,2.6,44.79.33L84.06,0c23.35,1.73,42.05,18.61,40.65,42.38-1.73,29.41-6.07,50.53-11.25,75.26-2.85,13.62-12.24,27.63-24.35,35.56-12.57,8.24-30.71,8.17-44.6,3.81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    className: "cls-2",
    d: "M116.25,22.93c0,10.5-24.18,19-54,19s-54-8.52-54-19,24.18-19,54-19,54,8.52,54,19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    className: "cls-3",
    d: "M116.25,22.93c0,10.5-24.18,19-54,19s-54-8.52-54-19,24.18-19,54-19S116.25,12.43,116.25,22.93Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    className: "cls-4",
    d: "M109.62,23.06c0,8.11-21,14.69-46.8,14.69S16,31.17,16,23.06,37,8.38,62.82,8.38s46.8,6.57,46.8,14.68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    className: "cls-5",
    d: "M4,82.23c2.32-3,32,12.65,77.1,7.74,21.95-2.39,35.81-8.38,37.67-6,2.39,3.1-16.36,18.44-39.88,22.56C39.22,113.5,1.24,85.78,4,82.23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    className: "cls-5",
    d: "M13.63,72.69c2-1.69,26.62,6.08,64.67,2.19,18.54-1.89,30.36-5.54,31.86-4.27C112.09,72.24,95.9,81.15,76,84c-33.59,4.86-64.8-9.32-62.38-11.34"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/Icon8.f58088b9eeb4eb1bea1a47640334ae96.svg";
export { ForwardRef as ReactComponent };